module.exports = __webpack_public_path__ + "img/corte-suprema.a6fc034e.png";